import React, { Component } from 'react';
import './heading.css';
import './animate.css';

export default class Heading extends Component {
  static propTypes = {};

  render() {
    return (
      <div className="heading">
        <div className="heading-container fadeInUp">
            <h1>The collaborative drawing app</h1>
            <p>Skwiz is a game where multiple people take turns creating a single drawing – without knowing what the others have contributed – until the reveal at the end!</p>
            <a href="https://apps.apple.com/us/app/skwiz/id1611258643?itsct=apps_box_badge&amp;itscg=30200" target="_blank" rel="noreferrer" style={{ display: "inline-block", overflow: "hidden", borderTopLeftRadius: "8px", borderTopRightRadius: "8px", borderBottomRightRadius: "8px", borderBottomLeftRadius: "8px", width: "142px", height: "48px" }}><img src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1649462400&h=7bfb51012737f033cc0282ac00a71ebe" alt="Download on the App Store" style={{borderTopLeftRadius: '8px', borderTopRightRadius: '8px', borderBottomRightRadius: '8px', borderBottomLeftRadius: '8px', width: '142px', height: '48px'}} /></a>
        </div>
      </div>
    );
  }
}
